import React from "react";
import { Formik, Field, Form } from "formik";
import {
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
} from "../Styles/InputStyle2";
import { Select, MenuItem } from "@mui/material";
import tw from "tailwind-styled-components";
import * as Yup from "yup";

const AssignmentDetails = ({ stepOneData, setSelectedForm,setFormData }) => {
    const initialValues = {
        assignedProperty: "",
        assignTo: "",
        currentStatus: "",
    };
    const validationSchema = Yup.object({
        assignedProperty: Yup.string().required("Select Property"),
        assignTo: Yup.string().required("Select Assign To"),
        currentStatus: Yup.string().required("Select Current Status"),
    });
    const assignedPropertyList = {
        "Property 1": ["Room 1", "Room 2", "Room 3"],
        "Property 2": ["Room 4", "Room 5", "Room 6"],
        "Property 3": ["Room 7", "Room 8", "Room 9"],
        "Property 4": ["Room 10", "Room 11", "Room 12"],
        "Property 5": ["Room 13", "Room 14", "Room 15"],
        "Property 6": ["Room 16", "Room 17", "Room 18"],
        "Property 7": ["Room 19", "Room 20", "Room 21"],
    };

    const handleBack = () => {
        setSelectedForm("2");

    }


    const handleSubmit = (values) => {
        const payload = {
            assignedProperty: values.assignedProperty,
            assignTo: values.assignTo,
            currentStatus: values.currentStatus,
        };
        setFormData((prevFormData) => ({
            ...prevFormData,
            assignmentDetails: values,
        }));

        setSelectedForm("4");
        console.log("payload data of assignment details", payload);
    };

    return (
        <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, setFieldValue, errors, touched }) => (
                <Form>
                    <ModalSubHeading>Step 3</ModalSubHeading>
                    <ModalHeading>Assignment/Location Details</ModalHeading>
                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label>Select Property *</Label>
                                <Select
                                    value={values.assignedProperty}
                                    onChange={(e) => {
                                        setFieldValue("assignedProperty", e.target.value);
                                    }}
                                    displayEmpty
                                    fullWidth
                                    className="px-2"

                                >
                                    <MenuItem value="" disabled>
                                        Select Property
                                    </MenuItem>
                                    {Object.keys(assignedPropertyList).map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {errors.assignedProperty && touched.assignedProperty && (
                                    <ErrorText>{errors.assignedProperty}</ErrorText>
                                )}
                            </InputGroup>

                            <InputGroup>
                                <Label htmlFor="assignTo">Assign To *</Label>
                                <FieldWrapper>
                                    <Select
                                        name="assignTo"
                                        id="assignTo"
                                        value={values.assignTo}
                                        onChange={(e) => setFieldValue("assignTo", e.target.value)}

                                        className="w-full pl-2"
                                        style={{ height: "40px" }}

                                    >
                                        <MenuItem value="1">Tenant</MenuItem>
                                        <MenuItem value="2">Maintenance Staff</MenuItem>
                                        <MenuItem value="3">Unassigned</MenuItem>
                                    </Select>
                                </FieldWrapper>
                                {errors.assignTo && touched.assignTo && (
                                    <ErrorText>{errors.assignTo}</ErrorText>
                                )}
                            </InputGroup>
                            <InputGroup>
                                <Label htmlFor="currentStatus">Current Status *</Label>
                                <FieldWrapper>
                                    <Select
                                        name="currentStatus"
                                        id="currentStatus"
                                        value={values.currentStatus}
                                        onChange={(e) => setFieldValue("currentStatus", e.target.value)}
                                        className="w-full pl-2"
                                        style={{ height: "40px" }}


                                    >
                                        <MenuItem value="1">Active</MenuItem>
                                        <MenuItem value="2">In Maintenance</MenuItem>
                                        <MenuItem value="3">Disposed</MenuItem>
                                        <MenuItem value="3">In Use</MenuItem>

                                    </Select>
                                </FieldWrapper>
                                {errors.currentStatus && touched.currentStatus && (
                                    <ErrorText>{errors.currentStatus}</ErrorText>
                                )}
                            </InputGroup>
                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={handleBack}>
                            Back
                        </SideCancelBtn>
                        <SubmitBtn type="submit">
                            Next
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const FieldWrapper = tw.div``
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const InputGroup = tw.div`w-full flex flex-col mt-2 md:mt-0`;
const Label = tw.label`text-sm text-gray-500 font-normal mb-1.5`;

export default AssignmentDetails;